import { useAuth } from '@on3/ui-lib/index';
import { databaseUrl } from '@on3/ui-lib/utils/api';
import { userHasPermission } from '@on3/ui-lib/utils/auth/access';
import { useDynamicRoute } from '@on3/ui-lib/utils/hooks/useDynamicRoute';
import clsx from 'clsx';

import styles from './AdminLink.module.scss';

interface AdminLinkProps {
  path: string;
  query?: Record<string, string | null | undefined>;
  compact?: boolean;
  roles?: string[];
  title?: string;
  className?: string;
}
export const AdminLink = ({
  path,
  query,
  compact,
  roles,
  title,
  className,
}: AdminLinkProps) => {
  const { formatHref } = useDynamicRoute();
  const { hasRdbAccess, user } = useAuth();
  const editLink = formatHref({
    path: databaseUrl + path,
    query,
    options: { resetQuery: true },
  });

  const canEdit = roles ? userHasPermission(roles, user) : hasRdbAccess();

  if (!canEdit) return null;

  return (
    <div
      className={clsx(styles.block, { [styles.compact]: compact }, className)}
    >
      <a href={editLink} rel="noopener noreferrer" target="_blank">
        {title ?? 'Edit'}
      </a>
    </div>
  );
};
